package ir.site.zero1plus.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toAttrs
import ir.site.zero1plus.helper.colorModeDetect
import ir.site.zero1plus.theme.PrimaryDark
import ir.site.zero1plus.theme.PrimaryLight
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text


val SectionHeadingStyle = CssStyle {
    base {
        Modifier
            .margin(topBottom = 60.px)
            .padding(bottom = 14.px)
            .fontSize(clamp(24.px, 5.vw, 28.px))
            .borderBottom(2.px  , style = LineStyle.Solid, color = colorModeDetect(
                PrimaryDark,
                PrimaryLight
            ))
    }
}


@Composable
fun SectionHeading(
    title: String
) {
    H2(
        attrs = SectionHeadingStyle.toAttrs()
    ) {
        Text(title)
    }
}